import { render, staticRenderFns } from "./customerStatusChangeDialog.vue?vue&type=template&id=1f775c7d&scoped=true"
import script from "./customerStatusChangeDialog.vue?vue&type=script&lang=ts"
export * from "./customerStatusChangeDialog.vue?vue&type=script&lang=ts"
import style0 from "./customerStatusChangeDialog.vue?vue&type=style&index=0&id=1f775c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f775c7d",
  null
  
)

export default component.exports